import strings from "components/release/useful-links/UsefulLinks.strings.json";
import { generateLinksBase } from "components/release/useful-links/helpers/generateLinksBase";
import {
  LinkOptions,
  linksMap,
} from "components/release/useful-links/helpers/linksMap";
import type { SemVer } from "util/version";

// Generate list of links for Sentry Issue Feed for minor build version
export const generateSentryIssueFeedLinks = (
  versions: SemVer[],
): JSX.Element[] =>
  generateLinksBase(
    versions,
    strings.SentryIssueFeed,
    linksMap[LinkOptions.SENTRY_ISSUE_FEED],
  );

// Generate list of links for Sentry Dashboards for minor build version
export const generateSentryDashboardsLinks = (
  versions: SemVer[],
): JSX.Element[] =>
  generateLinksBase(
    versions,
    strings.SentryDashboards,
    linksMap[LinkOptions.SENTRY_DASHBOARDS],
  );
